div
<template>
  <div class="bg-white shadow-md relative rounded-lg p-8">
    <el-dialog title="" :visible.sync="centerDialogVisibleg" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">
          {{ AddEdit }} Testimonial
        </h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <!-- <div class="mb-3"></div> -->
          <div class="mt-3">
            <small class="fsize12 bg-white text-dark font-medium">Image</small>
            <div v-if="!image">
              <el-upload
                v-if="datavalue.length == 0"
                class="upload-demo mt-1 category-uploader"
                drag
                action="#"
                :before-upload="multipleimages"
                accept="image/*"
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">
                  Drop file here or <em>click to upload</em>
                </div>
                <!-- <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div> -->
              </el-upload>
            </div>
            <div
              v-if="renderedmultipleImage && renderedmultipleImage.length > 0"
            >
              <div
                v-for="(item, index) in renderedmultipleImage"
                class="relative"
                :key="`${item}+${index}`"
              >
                <img :src="item" class="object-cover imgpre" />

                <div class="absolute top-0 right-0 bg-white rounded-full p-1">
                  <feather-icon
                    icon="XIcon"
                    svgClasses="w-3 h-3"
                    class="cursor-pointer"
                    @click="
                      () => {
                        datavalue.splice(index, 1);
                        renderedmultipleImage.splice(index, 1);
                      }
                    "
                  />
                </div>
              </div>
            </div>
            <div class="relative" v-if="image">
              <img :src="getImage(image)" class="object-cover imgpre" />

              <div class="absolute top-0 right-0 bg-white rounded-full p-1">
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="
                    () => {
                      this.image = '';
                    }
                  "
                />
              </div>
            </div>
          </div>
          <!-- <div class="mt-3" v-if="AddEdit === 'Edit'">
            <p>test</p>
            <el-upload
              v-if="datavalue.length == 0"
              class="upload-demo mt-1 category-uploader"
              drag
              action="#"
              :before-upload="multipleimages"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
             
            </el-upload>
            <div class="relative">
              <img :src="getImage(image)" class="object-cover imgpre" />

              <div class="absolute top-0 right-0 bg-white rounded-full p-1">
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="
                    () => {
                      this.image = '';
                    }
                  "
                />
              </div>
            </div>
          </div> -->
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium">Name</small>
            <el-form-item prop="name" class="">
              <el-input
                placeholder="Please input"
                v-model="ruleForm.name"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Testimonial</small
            >
            <el-form-item prop="testimonial" class="">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="Please input"
                maxlength="50"
                v-model="ruleForm.testimonial"
              >
              </el-input>
            </el-form-item>
          </div>
          <div class="flex w-full justify-center">
            <vs-button
              color="primary"
              @click.prevent="handleSubmit('ruleForm')"
              class="bg-primary px-8 rounded-lg"
              >Submit</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex w-full justify-end"></div>
    <div class="flex w-full justify-between items-center">
      <div class="w-full">
        <div class="relative">
          <el-input
            placeholder="Please input"
            v-model="search"
            class="rounded-none w-full"
          ></el-input>
          <div class="absolute top-0 right-0 mt-2 mr-2">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
      </div>
      <div class="w-1/4 flex justify-end">
        <vs-button
          color="primary"
          @click="openDialog('Add')"
          class="bg-primary px-8 rounded-lg"
          >Add Testimonial</vs-button
        >
      </div>
    </div>
    <div class="w-full">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          :index="indexmethod"
          type="index"
          label="Sr.no"
          width="80"
        ></el-table-column>
        <el-table-column prop="image" label="Image" min-width="50px">
          <template v-slot="{ row }">
            <img :src="getImage(row.image)" class="w-16 h-16" alt="banh" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.name }}</P>
          </template>
        </el-table-column>
        <el-table-column
          prop="testimonial"
          label="Testimonial"
          min-width="50px"
        >
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.testimonial }}</P>
          </template>
        </el-table-column>

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="openDialog('Edit', row)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer text-danger"
                @click="deletePopup(row._id)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full flex justify-end mt-6" v-if="totalRows">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="totalRows"
        :page-size="perPage"
        @current-change="setPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      tableData: [
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
      ],

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      AddEdit: "Add",
      image: "",
      testimonialId: "",

      ruleForm: {
        name: "",
        testimonial: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please Enter Name",
            trigger: "blur",
          },
        ],
        testimonial: [
          {
            required: true,
            message: "Please Enter Testimonial",
            trigger: "blur",
          },
        ],
      },

      renderedmultipleImage: [],
      datavalue: [],
    };
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("portfolioTestimonial", {
      testimonials: "testimonial",
    }),
  },
  watch: {
    async currentPage() {
      await this.getTestimonial();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getTestimonial();
      }, 500),
    },
  },
  methods: {
    openDialog(action, data = {}) {
      this.AddEdit = action;
      this.centerDialogVisibleg = true;

      if (action === "Edit") {
        this.ruleForm.name = data.name ? data.name : "";
        this.ruleForm.testimonial = data.testimonial ? data.testimonial : "";
        this.image = data.image ? data.image : "";
        this.testimonialId = data._id ? data._id : "";
        this.$refs["ruleForm"].resetFields();
      } else {
        this.resetForm();
      }
    },
    handleSubmit(formName) {
      this.ruleForm.name = this.ruleForm.name.trim();
      this.ruleForm.testimonial = this.ruleForm.testimonial.trim();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    resetForm() {
      this.$refs["ruleForm"].resetFields();
      this.ruleForm.name = "";
      this.ruleForm.testimonial = "";
      this.datavalue = [];
      this.renderedmultipleImage = [];
      this.image = "";
      this.testimonialId = "";
    },
    async multipleimages(file) {
      if (this.datavalue.length < 1) {
        this.datavalue.push(file);
      } else {
        this.datavalue.shift(file);
      }
      this.newHandlemultiple(file);
    },
    async newHandlemultiple(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        if (this.renderedmultipleImage.length < 1) {
          this.$emit("load", this.renderedmultipleImage.push(e.target.result));
        } else {
          this.$emit("load", this.renderedmultipleImage.shift(e.target.result));
        }
      };

      reader.readAsDataURL(rawFile);
    },
    handleClick(tab, event) {},
    handleClick(name) {
      this.$router.push({ name: name });
    },
    async deletePopup(testimonialId) {
      this.$swal({
        title: "Are you sure?",
        icon: "info",
        type: "Warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#cd3197",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(testimonialId);
        }
      });
    },
    async handleDelete(testimonialId) {
      let payload = {
        testimonialId: testimonialId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch(
        "portfolioTestimonial/delete",
        payload
      );
      this.currentPage = 1;
      this.getTestimonial();
    },
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    async onSubmit() {
      const payload = new FormData();
      payload.append("name", this.ruleForm.name);
      payload.append("testimonial", this.ruleForm.testimonial);
      if (this.datavalue && this.datavalue.length > 0)
        payload.append("image", this.datavalue[0]);
      payload.append("isAdmin", true);
      payload.append("adminId", this.login._id);

      // if (this.datavalue.length === 0 && !this.image) {
      //   this.$swal.fire({
      //     text: "Please Upload Image!",
      //     confirmButtonText: "Okay",
      //     confirmButtonColor: "#cd3197",
      //     showCancelButton: false,
      //   });
      //   return;
      // }

      // if (this.ruleForm.name === "" || this.ruleForm.testimonial === "") {
      //   this.$swal.fire({
      //     text: "All fields are Required!",
      //     confirmButtonText: "Okay",
      //     confirmButtonColor: "#cd3197",
      //     showCancelButton: false,
      //   });
      //   return;
      // }

      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        if (this.AddEdit === "Edit") {
          payload.append("testimonialId", this.testimonialId);

          const updateTestimonial = await this.$store.dispatch(
            "portfolioTestimonial/update",
            payload
          );

          if (updateTestimonial.code === 200) {
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Testimonial Created Successfully!",
              type: "success",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        } else {
          const createTestimonial = await this.$store.dispatch(
            "portfolioTestimonial/create",
            payload
          );

          if (createTestimonial.code === 200) {
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Testimonial Created Successfully!",
              type: "success",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        }
        this.ruleForm.name = "";
        this.ruleForm.testimonial = "";
        this.datavalue = [];
        this.renderedmultipleImage = [];
        this.getTestimonial();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
    async getTestimonial() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getTestimonial = await this.$store.dispatch(
          "portfolioTestimonial/get",
          payload
        );
        loader.close();
        if (getTestimonial.code === 200) {
          this.totalRows = this.testimonials.totalCount;
          this.tableData = this.testimonials.result;
        }
      } catch (error) {
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
    handleClose() {
      this.centerDialogVisibleg = false;
    },
  },
  async mounted() {
    await this.getTestimonial();
  },
};
</script>
<style>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
</style>
